var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgDevicesMapIcon = function SvgDevicesMapIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1650_144831)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 3,
    width: 28,
    height: 28,
    rx: 7,
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.3333,
    cy: 24.9993,
    rx: 6.33333,
    ry: 1.33333,
    fill: "#D9D9D9",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7983 13.525C26.0183 10.0525 22.9883 8.5 20.3333 8.5C20.3333 8.5 20.3333 8.5 20.3258 8.5C17.6783 8.5 14.6558 10.0525 13.8683 13.5175C12.9833 17.3875 15.3533 20.665 17.4983 22.735C18.2933 23.5 19.3133 24.486 20.3333 24.486C21.3533 24.486 22.3733 23.5 23.1608 22.735C25.3058 20.665 27.6758 17.395 26.7983 13.525ZM22.7933 14.1475L19.7933 17.1475C19.6808 17.26 19.5383 17.3125 19.3958 17.3125C19.2533 17.3125 19.1108 17.26 18.9983 17.1475L17.8733 16.0225C17.6558 15.805 17.6558 15.445 17.8733 15.2275C18.0908 15.01 18.4508 15.01 18.6683 15.2275L19.3958 15.955L21.9983 13.3525C22.2158 13.135 22.5758 13.135 22.7933 13.3525C23.0108 13.57 23.0108 13.93 22.7933 14.1475Z",
    fill: "#00BFA5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.5905,
    cy: 15.2282,
    r: 4.62857,
    fill: "#00BFA5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.3334,
    cy: 15.334,
    r: 3,
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1650_144831",
    x: 0,
    y: 0,
    width: 40,
    height: 40,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1650_144831"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1650_144831",
    result: "shape"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDevicesMapIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "devices-map-icon.d1fb09340f3dd0dd918ad22bd3a3abfc.svg";